import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { getCopy } from '../../data/siteCopy';
import './Contact.css';

const Contact = () => {
  const { language } = useLanguage();
  const copy = getCopy(language);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const subject = encodeURIComponent(language === 'pt' ? 'Contacto através do portfolio' : 'Contact through portfolio');
    const body = encodeURIComponent(
      `${language === 'pt' ? 'Nome' : 'Name'}: ${formData.name}\n${language === 'pt' ? 'Email' : 'Email'}: ${formData.email}\n\n${formData.message}`
    );

    window.location.href = `mailto:augusta.silva.design@gmail.com?subject=${subject}&body=${body}`;
    setIsSubmitted(true);
    setFormData({ name: '', email: '', message: '' });
  };

  return (
    <main className="contact">
      <section className="contact-header">
        <h1 className="contact-title">{copy.contact.title}</h1>
        <p className="contact-intro">{copy.contact.intro}</p>
      </section>

      <section className="contact-content">
        <div className="contact-grid">
          {/* Left Column - Contact Info */}
          <div className="contact-info">
            <div className="contact-method">
              <h2 className="contact-method-title">{copy.contact.emailTitle}</h2>
              <a 
                href="mailto:augusta.silva.design@gmail.com" 
                className="contact-method-link large"
              >
                augusta.silva.design@gmail.com
              </a>
            </div>

            <div className="contact-method">
              <h2 className="contact-method-title">{copy.contact.phoneTitle}</h2>
              <a 
                href="tel:+351914941486" 
                className="contact-method-link"
              >
                +351 914 941 486
              </a>
            </div>

            <div className="contact-method">
              <h2 className="contact-method-title">{copy.contact.socialsTitle}</h2>
              <div className="social-links">
                <a 
                  href="https://instagram.com/gusmagarts" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                  </svg>
                  @gusmagarts
                </a>
                <a 
                  href="https://www.linkedin.com/in/augusta-silva-design" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                >
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                    <rect x="2" y="9" width="4" height="12"></rect>
                    <circle cx="4" cy="4" r="2"></circle>
                  </svg>
                  LinkedIn
                </a>
              </div>
            </div>

            <div className="contact-method">
              <h2 className="contact-method-title">{copy.contact.locationTitle}</h2>
              <p className="contact-location">Porto, Portugal</p>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div className="contact-form-wrapper">
            <h2 className="form-title">{copy.contact.formTitle}</h2>
            
            {isSubmitted ? (
              <div className="form-success">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                <p>{copy.contact.success}</p>
                <button 
                  onClick={() => setIsSubmitted(false)}
                  className="form-reset-btn"
                >
                  {copy.contact.reset}
                </button>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name" className="form-label">{copy.contact.nameLabel}</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder={copy.contact.namePlaceholder}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="email" className="form-label">{copy.contact.emailLabel}</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder={copy.contact.emailPlaceholder}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message" className="form-label">{copy.contact.messageLabel}</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    className="form-textarea"
                    placeholder={copy.contact.messagePlaceholder}
                    rows="5"
                  ></textarea>
                </div>

                <button type="submit" className="form-submit">
                  {copy.contact.submit}
                </button>
              </form>
            )}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Contact;
